export default "__VITE_ASSET__CALAG21k__"